import { render, staticRenderFns } from "./PaxelRecycleMoreInfo.vue?vue&type=template&id=35e52c2a&"
import script from "./PaxelRecycleMoreInfo.vue?vue&type=script&lang=js&"
export * from "./PaxelRecycleMoreInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports